import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AddAdyenPaymentSettingsForm from './AddAdyenPaymentSettingsForm';

export type AdyenPaymentSettingsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    moduleId: string;
};

const AdyenPaymentSettingsDrawer = ({ onClose, visible, moduleId }: AdyenPaymentSettingsDrawerProps) => {
    const { t } = useTranslation(['adyenPaymentModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>
                        {t('adyenPaymentModuleDetails:paymentSettingsDrawer.cancelButton')}
                    </Button>
                    <Button form="addAdyenPaymentSettings" htmlType="submit" type="primary">
                        {t('adyenPaymentModuleDetails:paymentSettingsDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('adyenPaymentModuleDetails:paymentSettingsDrawer.title.create')}
            visible={visible}
            destroyOnClose
        >
            <AddAdyenPaymentSettingsForm moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default AdyenPaymentSettingsDrawer;

export const useAdyenPaymentSettingsDrawer = (moduleId: string) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <AdyenPaymentSettingsDrawer moduleId={moduleId} onClose={actions.close} visible={visible} />,
    };
};
